import MoveIn from './MoveIn';

export default MoveIn;
